<div class="oa-chip-row" *ngIf="filter?.activeFilters?.length" role="group" aria-label="Filtros aplicados"
    [class.oa-chip-row--on-brand]="variant === 'on-brand'">
    <button type="button" class="oa-chip" *ngFor="let chip of filter.activeFilters; trackBy: trackChip"
        [attr.aria-label]="'Remover filtro ' + chip.label" [title]="chip.label" (click)="filter.removeFilter(chip)">
        <span class="oa-chip__label">{{chip.label}}</span>
        <mat-icon aria-hidden="true">close</mat-icon>
    </button>
    <button *ngIf="showClear" type="button" class="oa-btn oa-btn--sm oa-chip-row__clear"
        [ngClass]="variant === 'on-brand' ? 'oa-btn--on-brand' : 'oa-btn--ghost'" (click)="filter.clearFilters()">
        Limpar filtros
    </button>
</div>
